<template>
	<header
		id="theme-header"
		ref="header"
		class="theme-header no-print"
		:class="[
			{
				'has-image': featuredImage || isFrontPage,
				'is-front-page': isFrontPage,
				'show-mobile': mainNaviIsOpen,
			},
			'scroll-' + scrollDir,
		]"
	>
		<div ref="mainbox" :class="{ 'show-mobile': mainNaviIsOpen }" class="holder-top">
			<div class="inner">
				<PageLogo :dark="showLight" class="dark-logo" />
				<PageLogo small class="light-logo" />
				<div class="top-buttons">
					<button class="search-btn header-btn" aria-label="Open page search" @click="openSearch">
						<span class="txt">Search</span>
						<span class="menu-ico" v-html="searchIcon"></span>
					</button>
					<button class="menu-btn header-btn" aria-label="Open mobile menu" @click="openMenu">
						<span class="txt">Menu</span>
						<span class="menu-ico" v-html="menuIcon"></span>
					</button>
				</div>
				<nav class="nav-block">
					<ul class="font--semiBold menu-container navi" :class="{ 'show-mobile': mainNaviIsOpen }">
						<template v-if="topLinks && topLinks.length">
							<li class="link" v-for="({ link }, k) in topLinks" :key="k">
								<AcfLink class="slide-hover" :data="link" />
							</li>
						</template>
						<li class="link search">
							<a class="slide-hover" @click.prevent="openSearch">Search</a>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</header>
</template>

<script>
import PageLogo from '@/components/elements/PageLogo'
import AcfLink from '@/components/elements/AcfLink'
import { menu, search } from '@/icons'

import { mapGetters, mapMutations } from 'vuex'

export default {
	props: {
		is404: {
			type: Boolean,
			default: false,
		},
	},
	name: 'theme-header',
	data() {
		return {
			firstTriggerMenu: false,
			firstTriggerSearch: false,
			lastScrollTop: 0,
			delta: 50,
			wpvue: window.WPVUE,
			navbarHeight: 0,
			scrollDir: 'back',
			menuIcon: menu('#9ca0a5'),
			searchIcon: search('#9ca0a5'),
		}
	},
	components: {
		PageLogo,
		AcfLink,
	},
	watch: {
		mainNaviIsOpen(v) {
			if (!this.firstTriggerMenu) {
				this.firstTriggerMenu = true
			}
		},
		searchModalOpen(v) {
			if (!this.firstTriggerSearch) {
				this.firstTriggerSearch = true
			}
			/*
            else if(v && this.$refs.searchSide){
                this.$refs.searchSide.setFocusonSearch()
            }
            */
		},
	},
	mounted() {
		window.addEventListener('scroll', this.wathScroll)
		this.wathScroll()
		if (this.$refs.mainbox) {
			this.navbarHeight = this.$refs.mainbox.getBoundingClientRect().height
			this.delta = this.navbarHeight / 3
			this.scrollDir = 'back'
		}
		/* if(this.$refs.header){
            const headerRect = this.$refs.header.getBoundingClientRect();
            if(headerRect){ this.$refs.header.style.minHeight = headerRect.height+'px' }
        } */
	},
	destroyed() {
		window.removeEventListener('scroll', this.wathScroll)
	},
	methods: {
		...mapMutations(['SEARCH_MODAL_CHANGE_STATE', 'MENU_OPEN_CHANGE_STATE']),
		openMenu() {
			this.MENU_OPEN_CHANGE_STATE()
		},
		openSearch() {
			this.SEARCH_MODAL_CHANGE_STATE()
		},
		wathScroll() {
			const st = window.pageYOffset
			const VM = this

			if (Math.abs(VM.lastScrollTop - st) <= 0) return

			/*             console.log('pageYOffset', st)
            console.log('lastScrollTop', VM.lastScrollTop)
            console.log('navbarHeight', VM.lastScrollTop) */

			if (st > 0) {
				// Scroll Down
				VM.scrollDir = 'down'
				//$('header').removeClass('nav-down').addClass('nav-up');
			} else {
				if (st <= VM.navbarHeight) {
					VM.scrollDir = 'back'
				} else if (st + window.innerHeight < document.documentElement.getBoundingClientRect().height) {
					/*                     console.log('1', document.documentElement.getBoundingClientRect().height)
                    console.log('2', window.innerHeight)
                    console.log('3', st) */
					VM.scrollDir = 'up'
				}
			}

			VM.lastScrollTop = st
		},
		hideAnyOpenMenu() {
			if (this.mainNaviIsOpen) {
				this.MENU_OPEN_CHANGE_STATE()
			}
			if (this.searchModalOpen) {
				this.SEARCH_MODAL_CHANGE_STATE()
			}
		},
	},
	computed: {
		...mapGetters(['featuredImage', 'currentPostType', 'isFrontPage', 'mainNaviIsOpen', 'searchModalOpen']),
		showLight() {
			// this.isFrontPage
			// this.is404
			if (this.isFrontPage) return true
			if (this.is404) return false
			return false
		},
		topLinks() {
			return this.wpvue.options.navigation
		},
	},
}
</script>

<style lang="scss">
@import './../assets/vars.scss';
@import './../assets/mixins.scss';
@import './../assets/extends.scss';
body {
	margin-top: 130px;
	@include mquery($tablet) {
		margin-top: 125px;
	}
	@include mquery($phone) {
		margin-top: 105px;
	}
	&.front-page {
		.theme-header {
			background: linear-gradient(180deg, rgba(34, 40, 49, 0.75) 0%, rgba(34, 40, 49, 0) 100%);
			color: #fff;
			.slide-hover {
				&:after {
					background-color: #fff;
				}
			}
			.header-btn {
				color: #fff;
				path {
					fill: #fff;
				}
			}
		}
	}
}

.theme-header {
	z-index: 999;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	transition: background-color 0.15s ease-in-out;
	pointer-events: none;
	.top-buttons {
		display: none;
		@include mquery($tablet) {
			display: block;
		}
	}
	.header-btn {
		pointer-events: all;
		border: none;
		background-color: transparent;
		cursor: pointer;
		transition: color 0.15s ease-in;
		display: flex;
		align-items: center;
		display: inline-flex;
		&.search-btn {
			margin-right: 15px;
		}
		span {
			display: block;
			font-weight: 600;
		}
		.menu-ico {
			margin-left: 10px;
		}
		svg {
			width: 18px;
			height: auto;
		}
		path {
			fill: var(--dark);
			transition: fill 0.15s ease-in;
		}
	}
	.inner {
		display: flex;
		padding: 50px;
		width: 100%;
		justify-content: space-between;
		transition: padding 0.15s ease-in-out;
		@include mquery(1350px) {
			padding-top: 30px;
		}
		@include mquery($tablet) {
			padding: 30px;
			align-items: center;
		}
		@include mquery($phone) {
			padding: 20px;
		}
	}
	.light-logo {
		display: none;
	}
	.search {
		a {
			cursor: pointer;
		}
	}

	// &.is-front-page{
	// }
	// &.has-image{
	// }
	.page-logo {
		pointer-events: all;
		img {
			transition: all 0.15s ease-in-out;
			height: 113px;
			@include mquery(1350px) {
				height: 60px;
			}
		}
	}
	.nav-block {
		display: flex;
		@include mquery($tablet) {
			display: none;
		}
	}
	.menu-container {
		list-style: none;
		display: flex;
		margin: 0;
		pointer-events: all;
		@include mquery(1350px) {
			align-items: center;
		}
		.link {
			margin-right: 50px;
			&:last-child {
				margin-right: 0;
			}
			a {
				text-decoration: none;
				&.router-link-exact-active {
					&:after {
						transform: scaleX(1);
					}
				}
			}
		}
	}

	&.scroll-up,
	&.scroll-down {
		background-color: var(--dark) !important;
		color: #fff;
		.header-btn {
			color: #fff;
			path {
				fill: #fff;
			}
		}

		.slide-hover {
			&:after {
				background-color: #fff;
			}
		}
		.light-logo {
			display: block;
		}
		.dark-logo {
			display: none;
		}
		.page-logo {
			img {
				height: 40px;
			}
		}
		.inner {
			padding-top: 10px;
			padding-bottom: 10px;
		}
	}
	&.scroll-up,
	&.scroll-down {
		.holder-top {
			//padding-top: 15px;
			//padding-bottom: 15px;
			@include mquery($tablet) {
				//padding-top: 10px;
				//padding-bottom: 10px;
			}
			.menu-container {
				align-items: center;
			}
		}
	}
	&.scroll-back {
		.holder-top {
			transition: all 0s ease-in-out;
		}
	}
	&.scroll-up {
		.holder-top {
			transition: all 0.2s ease-in-out;
			top: 0;
		}
	}
	&.scroll-down {
		.holder-top {
			top: 0;
		}
	}
}
</style>
